import type { UsageEvent, AdPlacement } from "@serendiptv/contracts";

export class UsageMeter {
  private last: number;
  private state = { visible: false, playing: false, guide: false };
  private delta = { visible_ms: 0, playback_ms: 0, guide_ms: 0 };
  queue: UsageEvent[] = [];
  sending = false;
  lastCompletedChannel: number | null = null;
  constructor(readonly sessionId: string, private now = () => performance.now(), private uuid: () => string = () => crypto.randomUUID()) { this.last = now(); }
  sample() {
    const current = this.now();
    // A suspended/throttled process must not backfill a long unobserved gap.
    const elapsed = Math.max(0, Math.min(5_000, Math.round(current - this.last)));
    this.last = current;
    if (!this.state.visible) return;
    let remaining = elapsed;
    while (remaining > 0) {
      const available = Math.min(remaining, 30_000 - this.delta.visible_ms);
      this.delta.visible_ms += available;
      if (this.state.guide) this.delta.guide_ms += available;
      else if (this.state.playing) this.delta.playback_ms += available;
      remaining -= available;
      if (this.delta.visible_ms >= 30_000) this.flush();
    }
  }
  update(state: typeof this.state) { this.sample(); this.state = state; }
  flush() {
    if (this.delta.visible_ms) this.enqueue({ id: this.uuid(), kind: "interval", ...this.delta });
    this.delta = { visible_ms: 0, playback_ms: 0, guide_ms: 0 };
  }
  event(kind: UsageEvent["kind"], placement?: AdPlacement) {
    this.sample(); this.flush();
    this.enqueue({ id: this.uuid(), kind, visible_ms: 0, playback_ms: 0, guide_ms: 0, ...(placement ? { placement } : {}) });
  }
  private enqueue(event: UsageEvent) { this.queue = [...this.queue.slice(-99), event]; }
  acknowledge(ids: Set<string>) { this.queue = this.queue.filter(event => !ids.has(event.id)); }
}

let documentMeter: UsageMeter | undefined;
export function getUsageMeter(sessionId: string) { return documentMeter ??= new UsageMeter(sessionId); }
export function adDiagnostic(kind: UsageEvent["kind"], placement: AdPlacement) { documentMeter?.event(kind, placement); }
